import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "./englishCrmMessages";
import {
  raSpanishMessages,
  raSupabaseSpanishMessages,
} from "./raSpanishMessages";
import { spanishCrmMessages } from "./spanishCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

// El inglés queda debajo solo como respaldo de llaves faltantes.
const spanishCatalog = mergeTranslations(
  englishCatalog,
  raSpanishMessages,
  raSupabaseSpanishMessages,
  spanishCrmMessages,
);

export const getInitialLocale = (): "es" => "es";

export const i18nProvider = polyglotI18nProvider(
  () => spanishCatalog,
  getInitialLocale(),
  [{ locale: "es", name: "Español" }],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
